var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigitalAndPhysical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 24,
    viewBox: "0 0 37 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18112:242741)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.9397 11.5863C2.9397 6.25667 7.27424 1.93115 12.627 1.93115C16.2203 1.93115 19.3565 3.87347 21.0347 6.7587H18.6803C17.7713 5.63377 16.5529 4.7659 15.1482 4.28701C15.5784 5.07955 15.9344 5.9196 16.2162 6.79155C15.3157 6.95835 14.6467 7.74077 14.6467 8.68973L14.646 9.65529H10.3676C10.2803 10.2829 10.2124 10.9298 10.2124 11.5863C10.2124 12.2429 10.2803 12.8801 10.3676 13.5174H14.6432L14.6379 21.034C13.9891 21.17 13.3165 21.2415 12.627 21.2415C7.27424 21.2415 2.9397 16.916 2.9397 11.5863ZM14.4888 7.72425C14.0718 6.34357 13.4415 5.05943 12.6367 3.90081C11.8318 5.05943 11.2015 6.34357 10.7845 7.72425H14.4888ZM4.87909 11.5863C4.87909 12.2525 4.97606 12.8994 5.13121 13.5174H8.40879C8.33121 12.8801 8.27303 12.2429 8.27303 11.5863C8.27303 10.9298 8.33121 10.2925 8.40879 9.65529H5.13121C4.97606 10.2732 4.87909 10.9201 4.87909 11.5863ZM8.78697 15.4484H5.92636C6.85727 17.0511 8.34091 18.2774 10.1252 18.8856C9.54333 17.8139 9.09727 16.6553 8.78697 15.4484ZM5.92636 7.72425H8.78697C9.09727 6.51736 9.54333 5.35874 10.1252 4.28701C8.34091 4.89529 6.85727 6.1215 5.92636 7.72425ZM10.7845 15.4484C11.2015 16.8291 11.8318 18.1132 12.6367 19.2718C13.4415 18.1132 14.0718 16.8291 14.4888 15.4484H10.7845Z",
    fill: "#8F8F8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0607 7.72412H17.5456C16.4692 7.72412 15.6159 8.58343 15.6159 9.65516L15.6062 21.2414C15.6062 22.3131 16.4692 23.1724 17.5456 23.1724H33.0607C34.1371 23.1724 35.0001 22.3131 35.0001 21.2414V9.65516C35.0001 8.58343 34.1371 7.72412 33.0607 7.72412ZM33.0607 21.2414H17.5456V15.4483H33.0607V21.2414ZM33.0607 11.5862H17.5456V9.65516H33.0607V11.5862Z",
    fill: "#8F8F8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18112:242741"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 24,
    fill: "white",
    transform: "translate(3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalAndPhysical);
export default __webpack_public_path__ + "static/media/digitalAndPhysical.baacfa38.svg";
export { ForwardRef as ReactComponent };